import React, { useCallback, useRef } from "react";

import { Box } from "@radix-ui/themes";
import { styled } from "@stitches/react";

import useMergeRefs from "../../../hooks/useMergeRefs";

const InputWrapper = styled(Box, {
  height: "var(--space-6)",
  width: "100%",
  padding: "1px",
  display: "flex",
});

const Input = styled("input", {
  appearance: "none",
  backgroundColor: "white",
  border: "none",
  borderRadius: "var(--radius-1)",
  padding: "var(--space-2) var(--space-2)",
  color: "var(--gray-12)",
  boxShadow: "0 0 0 1px var(--gray-a7)",
  cursor: "pointer",
  width: "100%",

  fontFamily: "system-ui",

  "&:focus": {
    outline: "2px solid var(--focus-8)",
    outlineOffset: "-1px",
  },
});

type DateInputProps = Omit<React.HTMLProps<HTMLInputElement>, "type">;

export const DateInput = React.forwardRef<HTMLInputElement, DateInputProps>(
  (props: DateInputProps, forwardRef: React.Ref<HTMLInputElement>) => {
    const inputRef = useRef<HTMLInputElement>(null);

    const handleClick = useCallback(() => {
      if (!inputRef.current) return;
      inputRef.current.showPicker();
    }, [inputRef]);

    return (
      <InputWrapper>
        <Input
          type="date"
          {...props}
          ref={useMergeRefs(inputRef, forwardRef)}
          onClick={handleClick}
        />
      </InputWrapper>
    );
  }
);
